import React, { useEffect, useState } from "react";
import { Flame, Timer, ArrowRight, X } from "lucide-react";
import { useCMS, useSectionEnabled } from "../context/CMSContext";

export default function PromoBar() {
  const { cms } = useCMS();
  const enabled = useSectionEnabled("promo");
  const promo = cms?.promo || {};
  const minutes = Number(promo.timerMinutes || 30);
  const [open, setOpen] = useState(true);
  const [seconds, setSeconds] = useState(minutes * 60 - 13);

  useEffect(() => {
    setSeconds(minutes * 60 - 13);
  }, [minutes]);

  useEffect(() => {
    const id = setInterval(() => setSeconds((s) => (s > 0 ? s - 1 : 0)), 1000);
    return () => clearInterval(id);
  }, []);

  if (!enabled || !promo.enabled || !open) return null;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;

  return (
    <div className="lm-promo-bar text-white text-xs sm:text-sm relative">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-2.5 flex items-center justify-center gap-2 sm:gap-3 flex-wrap pr-10">
        <Flame className="w-4 h-4 text-[#FF6B3D] flex-shrink-0" />
        {promo.label && (
          <span className="lm-chip-accent px-2 py-0.5 rounded-md text-[11px] font-bold whitespace-nowrap">
            {promo.label}
          </span>
        )}
        <span className="font-medium hidden sm:inline">
          {promo.text}
          {promo.oldPrice && (
            <span className="text-white/50 line-through ml-1">{promo.oldPrice}</span>
          )}
        </span>
        <span className="font-medium sm:hidden truncate max-w-[140px]">{promo.text}</span>
        <span className="hidden md:inline-flex items-center gap-1.5 bg-white/10 px-2.5 py-1 rounded-md">
          <Timer className="w-3.5 h-3.5 text-[#FF6B3D]" />
          <span className="font-mono text-xs">
            {String(m).padStart(2, "0")}m {String(s).padStart(2, "0")}s
          </span>
        </span>
        {promo.ctaText && (
          <a
            href={promo.ctaUrl || "#pricing"}
            className="lm-btn-accent px-3 py-1.5 rounded-md text-[11px] sm:text-xs font-bold inline-flex items-center gap-1 whitespace-nowrap"
          >
            {promo.ctaText} <ArrowRight className="w-3.5 h-3.5" />
          </a>
        )}
      </div>
      <button
        onClick={() => setOpen(false)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white"
        aria-label="Close"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
